import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/angle-down.svg")